import React, { useState } from 'react';

import { withGoogleMap, GoogleMap, Circle } from 'react-google-maps';
import { Box, Typography } from '@material-ui/core';
import LocationOnIcon from '@material-ui/icons/LocationOn';
import { useDispatch, useSelector } from 'react-redux';
import useStyles from './styles';

function Maps({
  coordinates,
  setMarkerCoordinates,
  setAddressFromMap,
  setShowButton,
}) {
  const classes = useStyles();
  const dispatch = useDispatch();
  const [showLabel, setShowLabel] = useState(true);
  const { currentLocation } = useSelector(state => state.adresses);

  async function handleDragCoords(markerPosition) {
    const location = `${markerPosition.lat},${markerPosition.lng}`;
    const res = await fetch(
      `https://maps.googleapis.com/maps/api/geocode/json?latlng=${location}&key=AIzaSyDnbHQ_2Q9POiAFe6k6D0iW3XiNicNNvdE`,
      { method: 'GET' }
    );
    const data = await res.json();
    const one = data.results[0] || null;
    setMarkerCoordinates(markerPosition);
    dispatch({
      type: '@adresses/SET_MARKER_COORD',
      markerCoordinates: markerPosition,
    });
    setAddressFromMap({
      name: '',
      zip_code:
        one.address_components[6] === undefined
          ? ''
          : one.address_components[6].long_name,
      public_place: one.address_components[1].short_name,
      number: one.address_components[0].long_name,
      complement: '',
      state: one.address_components[4].short_name,
      code_state: '',
      city: one.address_components[3].short_name,
      code_city: '',
      neighborhood: one.address_components[2].short_name,
      phone: '',
      comments: one.formatted_address,
      latitude: markerPosition.lat,
      longitude: markerPosition.lng,
    });
  }

  let ref;

  const MapWithAMarker = React.useCallback(
    withGoogleMap(() => (
      <GoogleMap
        // eslint-disable-next-line no-return-assign
        ref={mapRef => (ref = mapRef)}
        onDragStart={() => {
          setShowLabel(false);
          setShowButton(false);
        }}
        onDragEnd={() => {
          const pos = ref.getCenter().toJSON();
          handleDragCoords(pos);
          setShowLabel(true);
          setShowButton(true);
        }}
        draggable
        defaultOptions={{
          mapTypeControl: false,
          gestureHandling: 'greedy',
          disableDefaultUI: true,
          zoomControl: false,
          draggableCursor: 'default',
          draggingCursor: 'auto',
          scrollwheel: false,
          streetViewControl: false,
        }}
        defaultZoom={18}
        defaultCenter={coordinates}
      >
        <Circle
          options={{
            center: currentLocation,
            fillColor: '#ADD8E6',
            strokeWeight: 1,
            radius: 14,
            strokeOpacity: 0.5,
            strokeColor: '#ADD8E6',
          }}
        />
        <Circle
          options={{
            center: currentLocation,
            fillColor: '#6495ED',
            strokeWeight: 0,
            radius: 10,
            strokeOpacity: 0,
            strokeColor: '#6495ED',
          }}
        />
        <Circle
          options={{
            center: currentLocation,
            fillColor: '#0000FF',
            strokeWeight: 2,
            radius: 5,
            strokeColor: '#FFF',
          }}
        />
      </GoogleMap>
    )),
    [coordinates]
  );

  return (
    <Box className={classes.root}>
      <MapWithAMarker
        containerElement={<div style={{ height: '100%' }} />}
        loadingElement={<div style={{ height: `100%` }} />}
        mapElement={<div style={{ height: `100%` }} />}
      />
      {showLabel && (
        <>
          <Box
            style={{
              left: '50%',
              display: 'flex',
              justifyContent: 'center',
              flexDirection: 'column',
              alignItems: 'center',
              marginLeft: -70,
              marginTop: -120,
              position: 'absolute',
              top: '50%',
              background: '#fff',
              width: '140px',
              height: '60px',
              borderRadius: 5,
            }}
          >
            <Typography
              style={{
                textAlign: 'center',
                fontSize: 12,
                fontWeight: 'bold',
                color: '#000',
              }}
            >
              Você está aqui?
            </Typography>
            <Typography
              style={{ textAlign: 'center', fontSize: 12, color: '#999' }}
            >
              Ajuste a localização
            </Typography>
          </Box>
          <Box
            style={{
              width: 0,
              height: 0,
              borderLeft: '10px solid transparent',
              borderRight: '10px solid transparent',
              borderTop: '10px solid #FFF',
              left: '50%',
              marginLeft: -10,
              marginTop: -60,
              position: 'absolute',
              top: '50%',
            }}
          />
        </>
      )}
      <Box
        style={{
          left: '50%',
          marginLeft: -24,
          marginTop: -48,
          position: 'absolute',
          top: '50%',
        }}
      >
        <LocationOnIcon style={{ fontSize: 50, color: 'red' }} />
      </Box>
    </Box>
  );
}

export default Maps;
